import { AuthService } from './../../../core/auth.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { DSMessage, LastShowedMessage } from '../../../models/api/ds-message';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent implements OnInit, OnChanges {
  @Input() message: DSMessage;
  messageVisible: boolean = false;
  locale: string;
  constructor(
    private changeRef: ChangeDetectorRef,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.message && changes.message.currentValue) {
    //   if (
    //     (this.authService.isDSLocateUser() && this.message.showPharmacyApp)
    //   ) {
    //     if (this.message.validTo.getTime() > new Date().getTime()) {
    //       let lastShowedMessageString =
    //         localStorage.getItem('lastShowedMessage');
    //       if (lastShowedMessageString) {
    //         let lastShowedMessage: LastShowedMessage = JSON.parse(
    //           lastShowedMessageString
    //         );
    //         if (lastShowedMessage.id != this.message.id) {
    //           this.showMessage(this.message);
    //         } else if (
    //           lastShowedMessage.showTimes < this.message.totalShowTimes
    //         ) {
    //           this.showMessage(this.message, lastShowedMessage.showTimes);
    //         }
    //       } else {
    //         this.showMessage(this.message);
    //       }
    //     }
    //   }
    // }
  }

  private showMessage(message: DSMessage, showTimes: number = 0) {
    this.locale = this.authService.getLocale();

    this.messageVisible = true;
    localStorage.setItem(
      'lastShowedMessage',
      JSON.stringify({
        id: message.id,
        showTimes: 1 + showTimes,
      })
    );
    this.changeRef.detectChanges();
  }

  parseHtmlWithTrust(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit(): void {}
}
